import { VirusMonitorDay } from '../../models/models';

export type CssStyling = { [key: string]: string } | null | undefined;

const defaultStyling: CssStyling = { color: '#18181B', fontFamily: 'Akkurat', fontSize: '12px' };

const protectionBackground = (percent: number) => `rgba(39, 144, 73, ${percent}%)`;
const protectionTextColor = (percent: number) => (percent > 50 ? '#FAFAFA' : '#18181B');

/* Spray advice styling */
const noAdviceStyling: CssStyling = { ...defaultStyling, 'background-color': '#FAFAFA' };
const highStyling: CssStyling = { ...defaultStyling, 'background-color': '#b5061a', color: 'white' };
const uvIndexColorMap: Record<number, string> = {
  0: '#b0d4f1',
  1: '#4eb400',
  2: '#a0ce00',
  3: '#f7e400',
  4: '#f8b600',
  5: '#f88700',
  6: '#f85900',
  7: '#e82c0e',
  8: '#d8001d',
  9: '#b40000',
  10: '#800000',
  11: '#7b0070',
};
const protectedStyling = (percent: number): CssStyling => ({
  ...defaultStyling,
  'background-color': protectionBackground(percent),
  color: protectionTextColor(percent),
});

export const getAdviceTranslationKey = (day: VirusMonitorDay): string => {
  switch (day.sprayAdvice) {
    case 'Protected':
      return 'virusMonitor.sprayProtectionAdvice.protected';
    case 'Unprotected':
      return 'virusMonitor.sprayProtectionAdvice.notProtected';
    case 'SprayRecommended':
      return 'virusMonitor.sprayProtectionAdvice.recommended';
    default:
      return 'virusMonitor.sprayProtectionAdvice.noAdvice';
  }
}

export const getAdviceColorKey = (day: VirusMonitorDay): CssStyling => {
  switch (day.sprayAdvice) {
    case 'Protected':
      return protectedStyling(day.overallProtectionPercent);
    case 'SprayRecommended':
      return highStyling;
    default:
      return noAdviceStyling;
  }
}

export const getProtectionLevelStyling = (protectionLevelPercentage: number): CssStyling => {
  return { ...defaultStyling, 'background-color': protectionBackground(protectionLevelPercentage) };
};

const uvIndexTextColor = (index: number): string => (index >= 5 ? '#FAFAFA' : '#18181B');

export const getUvIndexStyling = (uvIndex: number | undefined): CssStyling => {
  if (uvIndex == null || uvIndex < 0) {
    return noAdviceStyling;
  }

  const clampedIndex = Math.min(Math.max(Math.round(uvIndex), 0), 11);
  return { ...defaultStyling, 'background-color': uvIndexColorMap[clampedIndex], color: uvIndexTextColor(clampedIndex) };
};
